<template>
    <div class="w-full md:w-4/5 m-auto py-6 px-12">
        <div v-if="template!==null" class="bg-white bg-gray-100 border px-2 py-2 mt-1 pb-6">
            <div class="px-4 bg-gray-100">
                <div>
                    <div class="p-8 -mb-8">
                        <h1 class="mb-8 font-bold text-3xl">Profile Page</h1>
                    </div>
                    <div id="personal_details_content"
                         class="bg-white border border-t-0 border-gray-300 overflow-hidden"
                    >
                        <div>
                            <h2 class="mb-3 mt-4 pl-8 font-bold text-2xl">Personal Details</h2>
                            <form id="smmr-form" @submit.prevent="update">
                                <div class="p-8 pb-2 flex flex-wrap" @change="dirtyForm()">
                                    <select-input
                                        v-model="form.title_id"
                                        :error="form.errors?.title_id"
                                        class="pr-6"
                                        label="Title"
                                        @update:modelValue="value = $event"
                                    >
                                        <option v-for="(value, index) in titles" :key="index" :value="value.reference">{{ value.name }}</option>
                                    </select-input>
                                    <text-input v-model="form.first_name"
                                                :error="form.errors?.first_name"
                                                class="pr-6" label="First Name"
                                                @update:modelValue="value = $event"
                                    />
                                    <text-input v-model="form.middle_name1" class="pr-6" label="Middle Name 1" @update:modelValue="value = $event" />
                                    <text-input v-model="form.middle_name2" class="pr-6" label="Middle Name 2" @update:modelValue="value = $event" />
                                    <text-input v-model="form.last_name"
                                                :error="form.errors?.last_name"
                                                class="pr-6" label="Last Name"
                                                @update:modelValue="value = $event"
                                    />
                                    <text-input v-model="form.preferred_name" class="pr-6" label="Preferred Name"
                                                @update:modelValue="value = $event"
                                    />
                                    <text-input
                                        v-model="form.email"
                                        :error="form.errors?.email"
                                        class="pr-6"
                                        label="Email"
                                        @update:modelValue="value = $event"
                                    />
                                    <text-input
                                        v-model="form.date_of_birth"
                                        type="date"
                                        :error="form.errors?.date_of_birth"
                                        class="pr-6" label="Email"
                                        @update:modelValue="value = $event"
                                    />
                                    <select-input v-model="form.gender_id"
                                                  :error="form.errors?.gender_id"
                                                  class="pr-6"
                                                  label="Gender"
                                                  @update:modelValue="value = $event"
                                    >
                                        <option v-for="(value, index) in genders" :key="index" :value="value.reference">{{ value.name }}</option>
                                    </select-input>
                                </div>

                                <div v-if="successMessage !== undefined">
                                    <div v-if="successMessage" class="success-message m-8 w-auto">{{ successMessage }}</div>
                                </div>
                                <div v-if="validationErrors !== undefined">
                                    <div v-if="Object.keys(validationErrors).length > 0">
                                        <p class="server-error m-8">There were some validation issues, please check the fields above</p>
                                    </div>
                                </div>
                                <div class="lg:flex justify-end w-full pb-2 -mt-8">
                                    <div class="relative w-auto lg:w-1/3 mx-8">
                                        <application-component-save-button :disabled="formDirty"
                                                                           class="w-full flex btn-green ml-auto mt-8 md:inline-block text-center"
                                                                           type="submit"
                                        >
                                            Save Profile Details
                                            <div v-if="loading" class="lds-ring-container absolute top-10">
                                                <div class="lds-ring">
                                                    <div />
                                                    <div />
                                                    <div />
                                                    <div />
                                                </div>
                                            </div>
                                        </application-component-save-button>
                                    </div>
                                </div>
                            </form>
                            <h2 class="mb-3 mt-4 pl-8 font-bold text-2xl">Change Password</h2>
                            <form id="smmr-change-password-form" @submit.prevent="updatePassword">
                                <div class="p-8 pb-2" @change="dirtyForm2()">
                                    <text-input v-model="changePassword.current" type="password" class="pr-6" :width="'full'" label="Current Password"
                                                @update:modelValue="value = $event"
                                    />
                                    <text-input v-model="changePassword.new" type="password" class="pr-6" :width="'full'" label="New Password"
                                                @update:modelValue="value = $event"
                                    />
                                    <text-input v-model="changePassword.new_confirmation" type="password" class="pr-6" :width="'full'"
                                                label="Confirm New Password" @update:modelValue="value = $event"
                                    />
                                </div>
                                <div v-if="successMessage2" class="success-message m-8 w-auto">{{ successMessage2 }}</div>
                                <div v-if="serverErrors2" class="m-8 server-error">
                                    <div v-for="(value, key) in serverErrors2" :key="key">
                                        {{ value[0] }}
                                    </div>
                                </div>
                                <div class="lg:flex justify-end w-full pb-2 -mt-8">
                                    <div class="relative w-auto lg:w-1/3 mx-8">
                                        <application-component-save-button :disabled="formDirty2"
                                                                           class="w-full flex btn-green ml-auto mt-8 md:inline-block text-center"
                                                                           type="submit"
                                        >
                                            Change Password
                                            <div v-if="loading" class="lds-ring-container absolute top-10">
                                                <div class="lds-ring">
                                                    <div />
                                                    <div />
                                                    <div />
                                                    <div />
                                                </div>
                                            </div>
                                        </application-component-save-button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TextInput from '../../shared/TextInput'
import SelectInput from '@/shared/SelectInput'
import ApplicationComponentSaveButton from '@/shared/ApplicationComponentSaveButton'

export default {
    name: 'Index',
    components: {
        TextInput,
        SelectInput,
        ApplicationComponentSaveButton,
    },
    metaInfo: {title: 'Referee Portal'},

    props: {
        displayData: Object,
    },
    data() {
        return {
            form: ({
                title: null,
                first_name: null,
                last_name: null,
                middle_name1: null,
                middle_name2: null,
                preferred_name: null,
                email: null,
                gender_id: null,
                city_town: null,
                date_of_birth: null,
                org: null,
                errors: {},
            }),
            changePassword: ({
                current: null,
                new: null,
                new_confirmation: null,
            }),
            genders: null,
            titles: null,

            formDirty: false,
            formDirty2: false,
            loading: false,
            successMessage: '',
            serverErrors: '',
            successMessage2: '',
            serverErrors2: '',
            template: '',
        }
    },
    computed: {
        validationErrors: {
            get: function() {
                return this.form.errors
            },
            set: function(newValue) {
                for (const key in newValue)
                {
                    this.form.errors[key] = newValue[key].join(' ')
                }
            },
        },

    },
    created() {
        this.loadPage()
    },
    methods: {
        update() {
            this.loading = true
            this.$store.dispatch('updateUserProfileData', {
                userData: this.form,
            })
                .then((response) => {
                    this.loading = false
                    this.serverErrors = ''
                    this.successMessage = response.data
                    this.form.errors = {}
                    setTimeout(() => {
                        this.serverErrors = ''
                        this.successMessage = ''

                    }, 3000)
                })
                .catch(error => {
                    this.loading = false
                    this.form.errors = error.response.data.errors
                    this.validationErrors = error.response.data.errors
                    this.serverErrors = Object.values(error.response.data.errors)
                    this.successMessage = ''
                })
            this.formDirty = false
        },
        updatePassword() {
            this.loading = true
            this.$store.dispatch('updateUserPassword', {
                passwordData: this.changePassword,
            })
                .then((response) => {
                    this.loading = false
                    this.serverErrors2 = ''
                    this.successMessage2 = response.data
                })
                .catch(error => {
                    this.loading = false
                    this.serverErrors2 = Object.values(error.response.data.errors)
                    this.successMessage2 = ''
                })
            this.formDirty = false
        },
        dirtyForm() {
            this.formDirty = true
            this.successMessage = ''
        },
        dirtyForm2() {
            this.formDirty2 = true
            this.successMessage2 = ''
        },
        loadPage() {
            this.$store.dispatch('getUserDetails')
                .then((response) => {
                    this.form = response.data.data
                    this.genders = response.data.genders
                    this.titles = response.data.titles
                })
                .catch(error => {
                    if (error.response.status && error.response.status === 404) {
                        this.template = '404'
                    }
                })
        },
    },
}
</script>

